import React, { lazy, Suspense, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import Style from "./../../assets/scss/custom.module.scss";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import { commonText, createPricingPlan, pricingPlan } from "../../locales/en";
import {
  getClientStatusThunk,
  getPricingGroupThunk,
  getPricingTypesThunk
} from "../../redux/pricingplanSlice";
import { useDispatch } from "react-redux";
const PricingPlanManagement = lazy(
  () => import("./tabs/PricingPlanManagement")
);
const BulkChangePricingPlan = lazy(
  () => import("./tabs/BulkChangePricingPlan")
);

export default function PricingPlan() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("PricingPlanManagement");

  const pricingPlanList = async () => {
    try {
      await dispatch(getPricingGroupThunk()).unwrap();
    } catch {
      // handle catch here;
    }
  };

  const loadPlanStatus = async () => {
    try {
      await dispatch(getPricingTypesThunk()).unwrap();
    } catch {
      // handle catch here;
    }
  };

  const fetchCustomerStatus = async () => {
    try {
      await dispatch(getClientStatusThunk()).unwrap();
    } catch {
      // handle catch here;
    }
  };

  useEffect(() => {
    pricingPlanList();
    loadPlanStatus();
    fetchCustomerStatus();
  }, []);

  return (
    <>
      <LoginAsUser />
      <TablePagesTitle mainTitle={createPricingPlan?.mainTitle} />

      <div className="row mt-4 mb-2 mx-0 ">
        <div
          className={`${Style.tabContainerCustom} tabcontainercustom col-12 pb-2`}
        >
          <Tabs
            defaultActiveKey="PricingPlanManagement"
            className="mb-3"
            onSelect={(k) => setActiveTab(k)}
          >
            <Tab
              eventKey="PricingPlanManagement"
              title={createPricingPlan?.mainTitle}
            >
              <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
                <PricingPlanManagement />
              </Suspense>
            </Tab>
            <Tab eventKey="Partner_Report" title={pricingPlan?.tab2Title}>
              {activeTab === "Partner_Report" && (
                <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
                  <BulkChangePricingPlan />
                </Suspense>
              )}
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
}
